import React, { useState } from "react"
import MyHeader from "../Header/Header"
import Navbar from "./Navbar"
import menusStatic from "./menus"
import { guideFooterMenu } from "./guideMenu"
import "./index.css"
import { useStore } from "../../ui"

function CustomIcon({ html }) {
  return <span dangerouslySetInnerHTML={{ __html: html || "" }} />
}

/** Ghép cấu trúc menu API với nhãn tiếng Việt có dấu từ menus.js (kể cả session cache cũ). */
function mergeTabTitles(tabs, staticTabs) {
  if (!tabs?.length) return staticTabs || []
  return tabs.map((tab) => {
    const staticTab = (staticTabs || []).find((s) => s.code === tab.code)
    return staticTab?.title ? { ...tab, title: staticTab.title } : tab
  })
}

function mergeMenusWithStatic(apiMenus, staticMenus) {
  if (!Array.isArray(apiMenus) || apiMenus.length === 0) return staticMenus
  return apiMenus.map((apiItem) => {
    const staticItem = staticMenus.find((s) => s.code === apiItem.code)
    const apiTabs = apiItem.tab || []
    const staticTabs = staticItem?.tab || []
    const sourceTabs = apiTabs.length > 0 ? apiTabs : staticTabs
    return {
      ...apiItem,
      title: staticItem?.title || apiItem.title,
      tab: mergeTabTitles(sourceTabs, staticTabs)
    }
  })
}

function hasPermission(permissions, required) {
  if (!required) return true
  return Array.isArray(permissions) && permissions.includes(required)
}

/** Tab URL đầy đủ (/surveillance/dashboard) dùng trực tiếp; URL ngắn (/list) ghép với base của menu cha. */
function resolveMenuHref(parentUrl, tabUrl) {
  const raw = String(tabUrl || "").trim()
  if (!raw) return parentUrl || "/"
  const normalized = raw.startsWith("/") ? raw : `/${raw}`
  const segments = normalized.split("/").filter(Boolean)
  if (segments.length >= 2) return normalized
  const baseUrl = parentUrl ? parentUrl.replace(/\/[^/]+$/, "") : ""
  return `${baseUrl || parentUrl || ""}${normalized}`
}

function convertMenus(menus, permissions) {
  if (!menus?.length) return []
  return menus
    .filter((i) => hasPermission(permissions, i.permission_required))
    .map((i) => {
    let __children = []
    const subItems = i.tab || i.sub_menu || []
    if (subItems.length > 0) {
      for (let index = 0; index < subItems.length; index++) {
        const t = subItems[index]
        if (!hasPermission(permissions, t.permission_required)) continue
        __children.push({
          href: resolveMenuHref(i.url, t.url),
          label: t.title || t.label || "",
          icon: t.icon ? <CustomIcon html={t.icon} /> : null
        })
      }
    }
    return {
      href: i.url,
      label: i.title,
      icon: <CustomIcon html={i.icon} />,
      children: __children
    }
  })
}

function MyLayout({ children }) {
  const { user, menus: menusFromApi, permissions } = useStore()
  const isShow = localStorage.getItem("isShow")
  const isMobile = typeof window !== "undefined" && window.innerWidth < 768
  // Mobile: mặc định ẩn sidebar (overlay) để tránh chiếm chỗ làm vỡ layout
  const [isNav, setIsNav] = useState(isMobile ? false : isShow !== "false")
  const menus = Array.isArray(menusFromApi) && menusFromApi.length > 0 ? mergeMenusWithStatic(menusFromApi, menusStatic) : menusStatic

  function toggleSidebar() {
    localStorage.setItem("isShow", !isNav)
    setIsNav((c) => !c)
  }

  return (
    <div className={`${isMobile ? "min-h-screen relative" : "flex min-h-screen"}`}>
      <Navbar
        items={convertMenus(menus, permissions)}
        footerItem={guideFooterMenu}
        isNav={isNav}
        isMobile={isMobile}
        onClose={toggleSidebar}
      />
      {isMobile && isNav && (
        // Nền mờ để chạm ra ngoài sẽ đóng sidebar (mobile UX)
        <div
          // Đặt z-index thấp hơn sidebar để click menu không bị overlay bắt
          className="fixed inset-0 bg-black/30 z-[5]"
          onClick={(e) => {
            // Chỉ đóng khi click đúng trên nền, không đóng khi click bên trong sidebar
            if (e.target === e.currentTarget) toggleSidebar()
          }}
          role="button"
          tabIndex={0}
          aria-label="Close sidebar"
        />
      )}
      <section className={`${isMobile ? "min-w-0 bg_layout_content" : "flex-grow min-w-0 bg_layout_content"}`}>
        <header className={`flex justify-between bg-base py-2 pr-6 pl-4 h-14 w-full ${isMobile ? "z-[50]" : "sticky top-0 z-[50]"}`}>
          <button onClick={toggleSidebar} className="text-slate-200 rounded">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-8 w-8"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h8m-8 6h16" />
            </svg>
          </button>
          <MyHeader user={user} />
        </header>
        <div className="p-6">{children}</div>
      </section>
    </div>
  )
}
export default MyLayout
